import React, { useEffect, useState } from 'react'
import './layout.scss'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { MdClose, MdCropLandscape, MdDashboard, MdHelp, MdKeyboardArrowDown, MdLock, MdMenu, MdOutlineGroup, MdOutlinePowerSettingsNew, MdPeople, MdPerson, MdSend, MdSettings, MdStars } from 'react-icons/md'
import { IoHelpOutline } from 'react-icons/io5';


function Layout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [role, setRole] = useState(null);

    const [isOpen, setIsOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const toggleSidebar = () => {
        if (window.innerWidth < 992) {
            setIsSidebarOpen(!isSidebarOpen)
        } else {
            setIsSidebarOpen(!isSidebarOpen)
        }
    }
    const closeSidebar = () => {
        if (window.innerWidth < 992) {
            setIsSidebarOpen(false);
        }
    };

    useEffect(() => {
        // let userData = JSON.parse(localStorage.getItem('userData') || '{}');
        let userRole = JSON.parse(localStorage.getItem('role'));
        // console.log(userData);
        if (!userRole) {
            navigate('/')
        } else {
            setRole(userRole);
        };
    }, [navigate]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setIsSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className='bootstrap-content'>
            <div className='d-flex h-100'>
                <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
                    <div className="logoCont">
                        {/* <img src={require('../../../assets/logo-final.jpeg')} alt='' /> */}
                        <div className="d-flex align-items-center">
                            {/* <p className="logo-heading mb-0 me-lg-2">Good Reviews</p> */}
                            <img src={require('../../assets/logo.png')} alt="Logo" className="logo" />
                        </div>
                    </div>
                    <div className='d-block d-lg-none mb-2'>
                        <MdClose className='close-icon' onClick={closeSidebar} />
                    </div>
                    <div className="menuCont">
                        {role === 2 && (
                            <div className='sidebarContainer'>
                                <Link to='/dashboard' className='text-decoration-none  text-black'>
                                    <div className={pathname === '/dashboard' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdDashboard fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Dashboard</h5>
                                    </div>
                                </Link>
                                <div className={`invitations-dropdown ${isOpen ? 'open' : ''}`}>
                                    <div className="sidebarcontent-invites" onClick={toggleDropdown}>
                                        <div className="sidebarcontent">
                                            <MdSend fontSize={'20px'} className={`sidebar-icon-invites ${isOpen ? 'rotated' : ''}`} />
                                            <h5 className='mb-0'>Invitations</h5>
                                        </div>
                                        <MdKeyboardArrowDown
                                            className={`dropdown-arrow me-3 ${isOpen ? 'open' : ''}`}
                                            fontSize={'20px'}
                                        />
                                    </div>
                                    {isOpen && (
                                        <div className="dropdown-content">
                                            <Link to='/single-invite' className='text-decoration-none  text-black'>
                                                <div className={pathname === '/single-invite' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                                    <h5 className='mb-0'>Single Invite</h5>
                                                    {/* <MdOutlineMailOutline fontSize={'18px'} className='sidebar-icon' /> */}
                                                </div>
                                            </Link>
                                            <Link to='/multiple-invites' className='text-decoration-none  text-black'>
                                                <div className={pathname === '/multiple-invites' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                                    <h5 className='mb-0'>Multiple Invites</h5>
                                                    {/* <MdOutlineMailOutline fontSize={'18px'} className='sidebar-icon' /> */}
                                                </div>
                                            </Link>
                                            {/* <Link to='/invite-settings' className='text-decoration-none  text-black'>
                                                <div className={pathname === '/invite-settings' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                                    <h5 className='mb-0'>Invite Settings</h5>
                                                </div>
                                            </Link> */}
                                        </div>
                                    )}
                                </div>
                                <Link to='/recipients' className='text-decoration-none'>
                                    <div className={pathname === '/recipients' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdOutlineGroup fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Recipients</h5>
                                    </div>
                                </Link>
                                <Link to='/manage-account-channels' className='text-decoration-none'>
                                    <div className={pathname === '/manage-account-channels' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdCropLandscape fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Channels</h5>
                                    </div>
                                </Link>
                                <Link to='/reviews' className='text-decoration-none'>
                                    <div className={pathname === '/reviews' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdStars fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Reviews</h5>
                                    </div>
                                </Link>
                                {/* <Link to='/business-settings' className='text-decoration-none'>
                                    <div className={pathname === '/business-settings' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdBusiness fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Business Settings</h5>
                                    </div>
                                </Link> */}
                                {/* <Link to='/reporting' className='text-decoration-none'>
                                    <div className={pathname === '/reporting' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdReport fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Reporting</h5>
                                    </div>
                                </Link> */}
                                <hr />
                                <Link to='/account-settings' className='text-decoration-none'>
                                    <div className={pathname === '/account-settings' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdSettings fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Settings</h5>
                                    </div>
                                </Link>
                                <Link to='/support' className='text-decoration-none'>
                                    <div className={pathname === '/support' ? 'sidebarcontent active' : 'sidebarcontent'}>
                                        <MdHelp fontSize={'20px'} className='sidebar-icon' />
                                        <h5 className='mb-0'>Support</h5>
                                    </div>
                                </Link>
                                <div className="sidebarcontent" onClick={() => {
                                    localStorage.clear();
                                    navigate('/')
                                }}>
                                    <MdOutlinePowerSettingsNew fontSize={'20px'} className='sidebar-icon' />
                                    <h5 className='mb-0'>Sign out</h5>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className='mainContent'>
                    <div className='header'>
                        <div className='d-flex align-items-center'>
                            <MdMenu fontSize={28} onClick={() => { toggleSidebar() }} />
                            {!isSidebarOpen && <div className="logoCont">
                                <div className="d-flex align-items-center">
                                    <img src={require('../../assets/logo.png')} alt="Logo" className="logo" />
                                </div>
                            </div>}
                        </div>
                        {role === 2 && <div className='d-flex align-items-center'>
                            {/* <button className='btn btn-dark rounded-pill px-lg-4 me-3 d-none d-lg-block' onClick={() => { navigate('/send-invites') }}>Send Invites</button> */}
                            <button className='btn btn-icon bg-dark text-white' onClick={() => { navigate('/support') }}><IoHelpOutline size={24} /></button>
                        </div>}
                    </div>
                    <div className="routeContainer">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Layout